import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LeadSourcesDataService } from '@services/lead-sources/lead-sources.data.service';
import {
	GraphsFilterObject,
	JobType,
	LeadSourceFullStatisticItem,
	SelectedDateRange,
	TableHeaderItem,
	ViewAllModalPayload
} from '@models/models';
import { TimeServiceProvider } from '@services/helpers/time-service/time.service';
import { Moment } from 'moment';
import { Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';
import { MessageService } from '@services/helpers/message-service/message.service';

import moment = require('moment');

@Component({
	selector: 'view-all-lead-sources',
	template: require('./view-all-lead-sources-modal.html'),
	styles: [require('./view-all-lead-sources-modal.scss')]
})
export class ViewAllLeadSourcesModalComponent implements OnInit {
	@Input() modalPayload: ViewAllModalPayload;

	selectedJobType: number;
	jobTypes: Array<JobType> | number;
	modalFilters: GraphsFilterObject;
	minDate: Moment;
	maxDate: Moment;
	selectedRange: SelectedDateRange;
	leadSourceTableData: Array<LeadSourceFullStatisticItem>;
	sortAscending = false;
	sortField: string;
	btnDisable: boolean;
	csvSpinner: boolean;
	xlsSpinner: boolean;

	readonly tableHeader: Array<TableHeaderItem> = [
		{ text: 'Status', isSortable: true, sortingCriteria: 'status' },
		{ text: 'Lead Source', isSortable: true, sortingCriteria: 'name' },
		{ text: 'Leads', isSortable: true, sortingCriteria: 'leadsCount' },
		{ text: 'Jobs', isSortable: true, sortingCriteria: 'jobsCount' },
		{ text: 'Total (%)', isSortable: true, sortingCriteria: 'count' },
		{
			text: 'Conversion',
			isSortable: true,
			sortingCriteria: 'conversationRateNumber'
		}
	];

	private unsubscribe: Subject<void> = new Subject<void>();

	constructor(
		private activeModal: NgbActiveModal,
		private timeService: TimeServiceProvider,
		private leadSourcesService: LeadSourcesDataService,
		private messageService: MessageService
	) {}

	ngOnInit(): void {
		this.gatherInitialData();
		this.loadLeadSourceUsageStatistic();
	}

	onDismiss(): void {
		this.activeModal.dismiss();
	}

	exportLeadSourceData(type: 'xls' | 'csv'): void {
		this.btnDisable = true;
		this[`${type}Spinner`] = true;

		this.leadSourcesService
			.exportLeadSourceData(this.modalFilters, type, this.generateFileName())
			.pipe(
				takeUntil(this.unsubscribe),
				finalize((): void => {
					this.btnDisable = false;
					this[`${type}Spinner`] = false;
				})
			)
			.subscribe(
				(): void => this.messageService.showToaster('s_5', 'leadSources'),
				({ error }): void => {
					const { errorTitle, errorMessage } = error;
					this.messageService.showErrorFromBackend(errorTitle, errorMessage);
				}
			);
	}

	orderByField(sortingField: string): void {
		if (this.sortField === sortingField) {
			this.sortAscending = !this.sortAscending;
		} else {
			this.sortField = sortingField;
			this.sortAscending = false;
		}
	}

	onJobTypeChange(newJobType: string): void {
		this.selectedJobType = parseInt(newJobType);
		this.applyChosenJobType();
		this.loadLeadSourceUsageStatistic();
	}

	setCustomDateRange(newDateRange: {
		startDate: Moment;
		endDate: Moment;
	}): void {
		if (moment.isMoment(newDateRange.startDate)) {
			const fromDate = this.timeService.getDateString(
				newDateRange.startDate.toDate()
			);
			const toDate = this.timeService.getDateString(
				newDateRange.endDate.toDate()
			);

			this.applyChosenDateRange(fromDate, toDate);
			this.loadLeadSourceUsageStatistic();
		}
	}

	applyChosenDateRange(fromDate: string, toDate: string): void {
		this.selectedRange = {
			startDate: new Date(fromDate).toISOString(),
			endDate: new Date(toDate).toISOString()
		};

		this.modalFilters.fromDate = this.selectedRange.startDate.slice(0, 10);
		this.modalFilters.toDate = this.selectedRange.endDate.slice(0, 10);
	}

	private applyChosenJobType(): void {
		if (this.selectedJobType === -1) {
			this.modalFilters.jobTypeId = null;
		} else {
			this.modalFilters.jobTypeId = this.selectedJobType;
		}
	}

	private loadLeadSourceUsageStatistic(): void {
		this.leadSourcesService
			.getAllLeadSourcesStatisticData(this.modalFilters)
			.pipe(takeUntil(this.unsubscribe))
			.subscribe(
				({ data }): void => {
					this.setDefaultSortParameters();
					this.leadSourceTableData = data;
				},
				({ err }): void => {
					const { errorMessage, errorTitle } = err;
					this.messageService.showErrorFromBackend(errorTitle, errorMessage);
					this.onDismiss();
				}
			);
	}
	private gatherInitialData(): void {
		this.setDefaultSortParameters();
		this.jobTypes = this.modalPayload.jobTypes;
		this.modalFilters = JSON.parse(
			JSON.stringify(this.modalPayload.selectedFilters)
		);
		this.selectedJobType = !this.modalFilters.jobTypeId
			? -1
			: this.modalFilters.jobTypeId;
		this.minDate = this.modalPayload.minDate;
		this.maxDate = this.modalPayload.maxDate;
		this.selectedRange = this.modalPayload.selectedRange;
	}

	private setDefaultSortParameters(): void {
		this.sortField = 'proportionNumber';
		this.sortAscending = false;
	}

	private generateFileName(): string {
		const startDate = moment(this.modalFilters.fromDate, 'YYYY-MM-DD').format(
			'DD-MMM-YYYY'
		);
		const toDate = moment(this.modalFilters.toDate, 'YYYY-MM-DD').format(
			'DD-MMM-YYYY'
		);

		return `Lead Sources Export ${startDate} - ${toDate}`;
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/dashboard/modals/view-all-lead-sources/view-all-lead-sources-modal.ts